module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.rutube-0b5e46686ec75d28a63ffbe63823ee4e.svg";